export function formatPhoneNumber(phoneNumber) {
  return phoneNumber.replace(/^(\+0?1\s)(\d{3})[\s.-](\d{3})[\s.-](\d+)/, '($2) $3-$4');
}
